import classNames from 'classnames'

type BaseButtonVariant = 'default' | 'info' | 'link'

type BaseButtonProps = React.ComponentPropsWithoutRef<'button'> & {
  variant?: BaseButtonVariant
}

const BASE_CLASSES =
  '~inline-block ~font-normal ~text-base ~text-center ~align-middle ~leading-normal ' +
  '~cursor-pointer ~select-none ~border ~rounded-[6px] ' +
  '~transition-[color,background-color,border-color,box-shadow] ~duration-150 ~ease-in-out ' +
  'focus:~outline-none focus:~shadow-[0_0_0_0.2rem_rgba(0,123,255,0.25)]'

const VARIANT_CLASSES: Record<BaseButtonVariant, string> = {
  default: '~bg-transparent ~border-transparent ~p-0',
  info:
    '~bg-[#0d85f4] ~border-[#0d85f4] ~text-white ~py-[0.375rem] ~px-[0.75rem] ' +
    'hover:~bg-[#0b77db] hover:~border-[#0b77db] ' +
    '~disabled:bg-[#cccccc] ~disabled:border-[#cccccc] ~disabled:cursor-not-allowed',
  link:
    '~bg-transparent ~border-transparent ~p-0 ~text-[#0d85f4] ' +
    'hover:~underline hover:~text-[#0b77db]',
}

const BaseButton: React.FC<BaseButtonProps> = ({
  variant = 'default',
  className,
  type = 'button',
  children,
  ...props
}) => (
  <button
    type={type}
    className={classNames(BASE_CLASSES, VARIANT_CLASSES[variant], className)}
    {...props}
  >
    {children}
  </button>
)

export default BaseButton
